import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { DataCenterTabs } from './DataCenterTabs';

interface DataCenterLayoutProps extends PropsWithChildren {
  href: string;
  activeTab: 'upload' | 'analyses';
  showTabs?: boolean;
}

/** Keep the page heading, navigation and content spacing consistent across the Data Center. */
export function DataCenterLayout({ href, activeTab, showTabs = true, children }: DataCenterLayoutProps) {
  const { t } = useTranslation('project');

  return (
    <div className='mx-auto w-full max-w-screen-lg px-4 pt-8 pb-12'>
      <header className='space-y-6'>
        <div>
          <h1 className='text-2xl font-semibold tracking-tight sm:text-3xl'>{t('dataCenter.title')}</h1>
          <p className='mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground'>{t('dataCenter.subtitle')}</p>
        </div>
        {showTabs && <DataCenterTabs href={href} activeTab={activeTab} />}
      </header>
      <div className='min-w-0 pt-8'>{children}</div>
    </div>
  );
}
